export const donationFieldsNames = ['description'] as const;

export type DonationFieldsNames = (typeof donationFieldsNames)[number];
